<template>
    <svg
        viewBox="0 0 180 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="180"
        height="28"
        class="group relative z-30 h-[2.75rem] w-auto lg:h-[3.75rem] xl:h-[4.75rem]">
        <path
            d="M80.4991 8.72696L84.2991 5.92695H71.6991V22.527H84.2991V19.727H75.2991V15.527H82.8991V12.727H75.2991V8.72696H80.4991ZM64.7991 8.72696L68.5991 5.92695H54.1991V22.527H61.6991C65.8991 22.527 68.2991 20.627 68.2991 17.327C68.2991 14.127 66.0991 12.427 62.0991 12.427H57.6991V8.72696H64.7991V8.72696ZM61.5991 15.127C63.8991 15.127 64.8991 15.927 64.8991 17.427C64.8991 18.927 63.7991 19.727 61.5991 19.727H57.7991V15.127H61.5991ZM94.3991 5.92695H87.5991V22.527H91.1991V17.827H94.4991C98.8991 17.827 101.599 15.527 101.599 11.827C101.599 8.12696 98.7991 5.92695 94.3991 5.92695V5.92695ZM94.3991 15.027H91.1991V8.62696H94.3991C96.6991 8.62696 97.9991 9.72696 97.9991 11.827C97.8991 13.927 96.6991 15.027 94.3991 15.027ZM48.0991 18.927C47.0991 19.427 46.0991 19.727 44.9991 19.727C41.7991 19.727 39.3991 17.427 39.3991 14.227C39.3991 11.027 41.6991 8.72696 44.9991 8.72696C46.1991 8.72696 47.2991 9.12696 48.2991 9.72696L50.8991 7.82696L50.6991 7.62696C49.1991 6.32695 47.1991 5.62695 44.8991 5.62695C42.3991 5.62695 40.1991 6.42695 38.4991 8.02696C36.8991 9.62696 35.8991 11.827 35.9991 14.127C35.9991 16.427 36.8991 18.627 38.4991 20.327C40.1991 21.927 42.4991 22.827 44.7991 22.727C47.3991 22.727 49.5991 21.827 51.1991 20.227L48.8991 18.527L48.0991 18.927ZM155.999 12.727H148.299V5.92695H144.699V22.527H148.299V15.727H155.999V22.527H159.599V5.92695H155.999V12.727ZM131.699 5.92695L124.499 22.527H128.099L129.499 19.227H137.099L138.499 22.527H142.299L135.299 5.92695H131.699V5.92695ZM130.699 16.427L133.499 9.72696L136.099 16.427H130.699ZM172.599 13.927L179.099 5.92695H174.999L169.599 13.027H167.599V5.92695H163.999V22.527H167.599V15.827H169.899L175.399 22.527H179.999L172.599 13.927ZM116.999 12.427H112.599V8.72696H121.999V5.92695H108.999V22.527H116.499C120.699 22.527 123.099 20.627 123.099 17.327C123.199 14.127 120.999 12.427 116.999 12.427V12.427ZM116.399 19.827H112.599V15.227H116.399C118.699 15.227 119.699 16.027 119.699 17.527C119.799 19.027 118.599 19.827 116.399 19.827V19.827Z"
            fill="currentColor"
            class="transition-colors duration-300 group-hover:!text-[#21A038]" />
        <path
            d="M24.4827 5.60547C25.1319 6.4561 25.6815 7.38024 26.1204 8.35933L13.6715 17.6596L8.46875 14.3543V10.3779L13.6715 13.6832L24.4827 5.60547Z"
            fill="currentColor"
            class="transition-colors duration-300 group-hover:!text-[#21A038]" />
        <path
            d="M3.15729 14.0772C3.15729 13.8987 3.16159 13.7215 3.17018 13.5453L0.0171718 13.3887C0.00644001 13.6171 3.81026e-06 13.8477 3.81026e-06 14.0804C-0.00133771 15.8987 0.351574 17.6994 1.0385 19.3791C1.72543 21.059 2.73284 22.5847 4.00296 23.869L6.23947 21.6035C5.26177 20.6166 4.48617 19.4437 3.95722 18.1521C3.42828 16.8604 3.15643 15.4756 3.15729 14.0772Z"
            fill="white"
            class="transition-opacity duration-300 group-hover:opacity-0" />
        <path
            d="M3.15729 14.0772C3.15729 13.8987 3.16159 13.7215 3.17018 13.5453L0.0171718 13.3887C0.00644001 13.6171 3.81026e-06 13.8477 3.81026e-06 14.0804C-0.00133771 15.8987 0.351574 17.6994 1.0385 19.3791C1.72543 21.059 2.73284 22.5847 4.00296 23.869L6.23947 21.6035C5.26177 20.6166 4.48617 19.4437 3.95722 18.1521C3.42828 16.8604 3.15643 15.4756 3.15729 14.0772Z"
            fill="url(#paint0_linear_0_1)"
            class="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <path
            d="M13.664 3.42613C13.84 3.42613 14.0149 3.43266 14.1887 3.44136L14.3465 0.24484C14.1205 0.233963 13.8929 0.228526 13.664 0.228526C11.8689 0.226307 10.0912 0.583453 8.43281 1.27945C6.77437 1.97546 5.26794 2.99661 4 4.28427L6.2365 6.55088C7.21029 5.5597 8.3678 4.77337 9.64249 4.23712C10.9172 3.70087 12.2838 3.42525 13.664 3.42613Z"
            fill="white"
            class="transition-opacity duration-300 group-hover:opacity-0" />
        <path
            d="M13.664 3.42613C13.84 3.42613 14.0149 3.43266 14.1887 3.44136L14.3465 0.24484C14.1205 0.233963 13.8929 0.228526 13.664 0.228526C11.8689 0.226307 10.0912 0.583453 8.43281 1.27945C6.77437 1.97546 5.26794 2.99661 4 4.28427L6.2365 6.55088C7.21029 5.5597 8.3678 4.77337 9.64249 4.23712C10.9172 3.70087 12.2838 3.42525 13.664 3.42613Z"
            fill="url(#paint1_linear_0_1)"
            class="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <path
            d="M13.668 24.7271C13.492 24.7271 13.317 24.7271 13.1421 24.713L12.9844 27.9084C13.2112 27.92 13.4391 27.9259 13.668 27.9259C15.4623 27.9277 17.2391 27.5704 18.8967 26.8742C20.5542 26.178 22.0597 25.1567 23.3266 23.869L21.0944 21.6035C20.1205 22.5942 18.9631 23.38 17.6886 23.9161C16.4142 24.4522 15.0478 24.7278 13.668 24.7271Z"
            fill="white"
            class="transition-opacity duration-300 group-hover:opacity-0" />
        <path
            d="M13.668 24.7271C13.492 24.7271 13.317 24.7271 13.1421 24.713L12.9844 27.9084C13.2112 27.92 13.4391 27.9259 13.668 27.9259C15.4623 27.9277 17.2391 27.5704 18.8967 26.8742C20.5542 26.178 22.0597 25.1567 23.3266 23.869L21.0944 21.6035C20.1205 22.5942 18.9631 23.38 17.6886 23.9161C16.4142 24.4522 15.0478 24.7278 13.668 24.7271Z"
            fill="url(#paint2_linear_0_1)"
            class="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <path
            d="M19.5924 5.28403L22.2495 3.29911C19.8209 1.306 16.7892 0.22103 13.6641 0.226584V3.42528C15.7803 3.42262 17.8473 4.07075 19.5924 5.28403Z"
            fill="white"
            class="transition-opacity duration-300 group-hover:opacity-0" />
        <path
            d="M19.5924 5.28403L22.2495 3.29911C19.8209 1.306 16.7892 0.22103 13.6641 0.226584V3.42528C15.7803 3.42262 17.8473 4.07075 19.5924 5.28403Z"
            fill="url(#paint3_linear_0_1)"
            class="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <path
            d="M27.3293 14.0757C27.331 13.2436 27.2591 12.4129 27.1146 11.5938L24.173 13.7907C24.173 13.8854 24.173 13.98 24.173 14.0757C24.1738 15.5639 23.866 17.0356 23.2696 18.3955C22.6732 19.7554 21.8014 20.9731 20.7109 21.9696L22.8326 24.3462C24.2504 23.049 25.3833 21.4645 26.1579 19.6953C26.9326 17.9259 27.3316 16.0114 27.3293 14.0757Z"
            fill="currentColor"
            class="transition-colors duration-300 group-hover:!text-[#21A038]" />
        <path
            d="M13.6653 24.7274C12.1968 24.7279 10.7445 24.4159 9.4025 23.8115C8.06056 23.2071 6.8588 22.3237 5.87507 21.2188L3.53125 23.3679C4.81097 24.8049 6.37443 25.9533 8.12025 26.7385C9.86606 27.5237 11.7552 27.9284 13.6653 27.9261V24.7274Z"
            fill="white"
            class="transition-opacity duration-300 group-hover:opacity-0" />
        <path
            d="M13.6653 24.7274C12.1968 24.7279 10.7445 24.4159 9.4025 23.8115C8.06056 23.2071 6.8588 22.3237 5.87507 21.2188L3.53125 23.3679C4.81097 24.8049 6.37443 25.9533 8.12025 26.7385C9.86606 27.5237 11.7552 27.9284 13.6653 27.9261V24.7274Z"
            fill="url(#paint4_linear_0_1)"
            class="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <path
            d="M6.61938 6.18114L4.49878 3.80469C3.08065 5.10154 1.94732 6.686 1.1723 8.45532C0.397286 10.2246 -0.00211296 12.1393 8.40637e-06 14.0751H3.1573C3.15665 12.587 3.46451 11.1152 4.0609 9.75537C4.65731 8.39554 5.52896 7.17781 6.61938 6.18114Z"
            fill="white"
            class="transition-opacity duration-300 group-hover:opacity-0" />
        <path
            d="M6.61938 6.18114L4.49878 3.80469C3.08065 5.10154 1.94732 6.686 1.1723 8.45532C0.397286 10.2246 -0.00211296 12.1393 8.40637e-06 14.0751H3.1573C3.15665 12.587 3.46451 11.1152 4.0609 9.75537C4.65731 8.39554 5.52896 7.17781 6.61938 6.18114Z"
            fill="url(#paint5_linear_0_1)"
            class="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <defs>
            <linearGradient
                id="paint0_linear_0_1"
                x1="4.64151"
                y1="23.4699"
                x2="1.10907"
                y2="13.3939"
                gradientUnits="userSpaceOnUse">
                <stop
                    offset="0.14"
                    stop-color="#F1E813" />
                <stop
                    offset="0.3"
                    stop-color="#E6E418" />
                <stop
                    offset="0.58"
                    stop-color="#C9DA26" />
                <stop
                    offset="0.89"
                    stop-color="#A2CC39" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_0_1"
                x1="4.90147"
                y1="4.84984"
                x2="13.8161"
                y2="1.4977"
                gradientUnits="userSpaceOnUse">
                <stop
                    offset="0.06"
                    stop-color="#0FA7DF" />
                <stop
                    offset="0.54"
                    stop-color="#0098F8" />
                <stop
                    offset="0.92"
                    stop-color="#0290EA" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_0_1"
                x1="12.7762"
                y1="25.9953"
                x2="22.8361"
                y2="23.7528"
                gradientUnits="userSpaceOnUse">
                <stop
                    offset="0.12"
                    stop-color="#A2CC39" />
                <stop
                    offset="0.28"
                    stop-color="#86C239" />
                <stop
                    offset="0.87"
                    stop-color="#219F38" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_0_1"
                x1="13.0073"
                y1="1.29789"
                x2="21.6168"
                y2="3.91946"
                gradientUnits="userSpaceOnUse">
                <stop
                    offset="0.06"
                    stop-color="#0290EA" />
                <stop
                    offset="0.79"
                    stop-color="#0C89CA" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_0_1"
                x1="4.32325"
                y1="22.9785"
                x2="13.7032"
                y2="26.4376"
                gradientUnits="userSpaceOnUse">
                <stop
                    offset="0.13"
                    stop-color="#F1E813" />
                <stop
                    offset="0.3"
                    stop-color="#EAE616" />
                <stop
                    offset="0.53"
                    stop-color="#D8DF1F" />
                <stop
                    offset="0.8"
                    stop-color="#BAD52D" />
                <stop
                    offset="0.98"
                    stop-color="#A2CC39" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_0_1"
                x1="1.17621"
                y1="14.4623"
                x2="5.01742"
                y2="4.6026"
                gradientUnits="userSpaceOnUse">
                <stop
                    offset="0.07"
                    stop-color="#A2CC39" />
                <stop
                    offset="0.26"
                    stop-color="#81C45E" />
                <stop
                    offset="0.92"
                    stop-color="#0FA7DF" />
            </linearGradient>
        </defs>
    </svg>
</template>
<script setup lang="ts"></script>
